import React from 'react';
import styled from 'styled-components';
import DashboardEngTitle from '../../Molecule/Card/CardEngTitle/DashboardTitle';
import DashboardKorTitle from '../../Molecule/Card/CardKorTitle/DashboardTitle';
import RateCount from '../../Molecule/Count/RateCount';
import TimeCount from '../../Molecule/Count/TimeCount';
import ValueCount from '../../Molecule/Count/ValueCount';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 159px;

  background-color: white;
  border-radius: 16px;
  padding: 24px;

  .voda_dashboard_eng_title {
    margin-bottom: 8px;
  }

  .voda_dashboard_kor_title {
    margin-bottom: 24px;
  }
`;

const CountWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface DashboardDefaultCardProps {
  titleEng: string;
  titleKor: string;
  isTimeCount: boolean;
  isLoading: boolean;
  value?: number;
  rate?: number;
  time?: number;
}

const DashboardDefaultCard = ({
  titleEng,
  titleKor,
  isTimeCount,
  isLoading,
  value,
  rate,
  time,
}: DashboardDefaultCardProps) => {
  return (
    <Component>
      <DashboardEngTitle title={titleEng} />
      <DashboardKorTitle title={titleKor} />
      {isLoading ? (
        <Spinner />
      ) : (
        <CountWrapper>
          {isTimeCount ? (
            <TimeCount time={time} />
          ) : (
            <ValueCount value={value} />
          )}
          <RateCount rate={rate} />
        </CountWrapper>
      )}
    </Component>
  );
};
export default DashboardDefaultCard;
